import React, { useCallback, useEffect, useState } from "react";
import { apiClient, useAuth } from "@/lib/auth";
import { LoginPinButton, useLoginPinRefresh } from "@/components/console/LoginPin";
import { Row } from "./ProfileTab";

/** Profile card row: PACT Life Pass login & PIN status (never the PIN) + the shared Set login & PIN action. */
export function LoginPinRow({ resident }) {
  const { user } = useAuth();
  const staff = user && user.role !== "partner_user" && user.role !== "resident";
  const [s, setS] = useState(null);
  const load = useCallback(() => { if (staff) apiClient.get(`/accounts/login-pin/resident/${resident.id}`).then(({ data }) => setS(data)).catch(() => setS(null)); }, [staff, resident.id]);
  useEffect(() => { load(); }, [load, resident]);
  useLoginPinRefresh((e) => { if (e.detail?.id === resident.id) load(); });
  if (!staff || !s) return null;
  return (
    <Row label="Login & PIN" testId="profile-login-pin">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span data-testid="profile-login-pin-status">{s.has_pin ? "Set" : "Not set"}{s.pin_changed_at ? ` · changed ${new Date(s.pin_changed_at).toLocaleDateString()}` : ""}{s.phone_last4 ? ` · login ••• ${s.phone_last4}` : ""}</span>
        {s.can_set && <div><LoginPinButton kind="resident" id={resident.id} name={`${resident.first_name} ${resident.last_name}`} login={s.login} status={s.status} source="resident_profile_card" note /></div>}
      </div>
    </Row>
  );
}
